import React from 'react';

import CallMadeRoundedIcon from '@mui/icons-material/CallMadeRounded';

import { SidebarItem } from '../../SidebarItem/SidebarItem';
import { SidebarLinkItem } from '../../../../../interfaces/system/SidebarNavConfig';
import { PATH_TYPE } from '../../../../../constants/system/headerSettings';
import { useIsActivePage } from '../../../../../hooks/useIsActivePage';
import { getNavigationIcon } from '../../../../../utils/navigationUtils/getNavigationIcon/getNavigationIcon';

type SidebarMenuElementProps = {
  item: SidebarLinkItem;
  onClick?: () => void;
};

/**
 * Rendered as a child of MUI `Menu` instead of `MenuItem` so the item reuses
 * `SidebarItem` styles. `tabIndex={-1}` is required: MUI MenuList arrow-key
 * navigation skips children without a `tabindex` attribute.
 */
const SidebarMenuElement = ({ item, onClick }: SidebarMenuElementProps) => {
  const { label, path, pathType, icon } = item;

  const isActive = useIsActivePage({ url: path });

  const isExternal = pathType === PATH_TYPE.EXTERNAL_LINK;
  const href = isExternal ? path : `#!${path}`;
  const target = isExternal ? '_blank' : undefined;
  const rel = isExternal ? 'noopener noreferrer' : undefined;

  return (
    <SidebarItem
      as="a"
      size="menu"
      role="menuitem"
      tabIndex={-1}
      href={href}
      target={target}
      rel={rel}
      onClick={onClick}
      startIcon={getNavigationIcon(icon)}
      label={label}
      endIcon={isExternal ? <CallMadeRoundedIcon /> : undefined}
      active={!!isActive}
      activeHighlight
    />
  );
};

export { SidebarMenuElement };
